<!--
 * @Date: 2019-11-07 12:06:14
 * @LastEditors: xshaobaozi
 * @LastEditTime: 2020-07-22 14:17:39
 -->
<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import * as globalEnum from "src/common/global-enum";
const textAlign = "right";
const labelWidth = 90;

@Component({
  name: "print-head",
  components: {}
})
export default class App extends Vue {
  @Prop({ type: String, default: "广州尚岑服饰有限公司" }) title;
  mounted() {}
  render(h) {
    return (
      <div class="print-head-layout">
        <p class="print-head-layout__head">{this.title}</p>
      </div>
    );
  }
}
</script>

<style lang="scss" scoped>
.print-head-layout {
  text-align: center;
  font-weight: 500;
  .print-head-layout__head {
    font-size: 6mm;
  }
  .print-head-layout__bottom {
    font-size: 5mm;
    margin: inherit;
  }
}
</style>
